import styled from 'styled-components'
import { cyberColors } from '../../lib/colors'

export const BetReplyWrapper = styled.div`
  width: 100%;
  height: 100%;
  max-width: 315px;
  display: flex;
  align-items: center;
`

export const BetReplyBox = styled.div`
  width: 100%;
  background: #26262d;
  padding: 10px;
  border-radius: 4px;
  z-index: 1;
`
export const Header = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  color: ${cyberColors.whiteText};
  font-size: 16px;
  text-transform: uppercase;
  p {
    color: ${cyberColors.whiteDark};
    margin-left: 5px;
  }
`

export const NotFound = styled.div`
  text-transform: uppercase;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 40px;
  color: ${cyberColors.whiteText};
  background: ${cyberColors.greyLight};
  border-radius: 4px;
  span {
    width: 4px;
    height: 4px;
    background: ${cyberColors.whiteText};
    transform: translateY(1.2px);
    margin: 0 2px;
    animation: load 1s infinite linear;
    border-radius: 1px;
    :nth-child(2) {
      animation-delay: 0.3s;
    }
    :last-child {
      animation-delay: 0.6s;
    }
  }
  @keyframes load {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`
